import React from "react";
import { Redirect, Route } from "react-router-dom";
import { store } from "../redux/store";

// reset password
const ForgetPassword = React.lazy(() => import("../pages/auth/ForgetPassword"));
const ResetPassword = React.lazy(() => import("../pages/auth/ResetPassword"));
const SuccessResetPassword = React.lazy(() => import("../pages/auth/SuccessReset"));

// 404
const NotFound = React.lazy(() => import("../pages/other/Error404"));

// handle auth and authorization
const PrivateRoute = ({ component: Component, roles, ...rest }) => {
    const { user } = store.getState().Auth;
    return (
        <Route
            {...rest}
            render={(props) => {
                if (user === null) {
                    // not logged in so redirect to login page with the return url
                    return <Redirect to={{ pathname: "/account/forget-password", state: { from: props.location } }} />;
                }

                // const loggedInUser = getLoggedInUser();
                // // check if route is restricted by role
                // if (roles && roles.indexOf(loggedInUser.role) === -1) {
                //     // role not authorised so redirect to home page
                //     return <Redirect to={{ pathname: '/' }} />;
                // }

                // authorised so return component
                return <Component {...props} />;
            }}
        />
    );
};

// root routes
const rootRoute = {
    path: "/",
    exact: true,
    component: () => <Redirect to="/dashboard" />,
    route: PrivateRoute,
};

// not found route
const notFoundRoute = {
    path: "*",
    exact: true,
    component: NotFound,
    route: Route,
};

const forgetPassword = {
    path: "/account/forget-password",
    exact: true,
    name: "Forget Password",
    component: ForgetPassword,
    route: Route,
};

const resetPassword = {
    path: "/account/reset-password/:product_name/:link_id",
    exact: true,
    name: "Reset Password",
    component: ResetPassword,
    route: Route,
};

const successReset = {
    path: "/account/reset-password/success",
    exact: true,
    component: SuccessResetPassword,
    route: Route,
};

// flatten the list of all nested routes
const flattenRoutes = (routes) => {
    let flatRoutes = [];

    routes = routes || [];
    routes.forEach((item) => {
        flatRoutes.push(item);

        if (typeof item.children !== "undefined") {
            flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
        }
    });
    return flatRoutes;
};

// All routes
const allRoutes = [rootRoute, forgetPassword, resetPassword, successReset, notFoundRoute];

const authProtectedRoutes = [];
const allFlattenRoutes = flattenRoutes(allRoutes);
export { allRoutes, authProtectedRoutes, allFlattenRoutes };
